// Capture globale de l'événement "beforeinstallprompt" (PWA).
// L'événement est émis très tôt par le navigateur : on le stocke ici
// pour pouvoir déclencher l'installation depuis n'importe quel composant.
let deferredPrompt = null;
let installed = window.matchMedia?.("(display-mode: standalone)")?.matches || false;
const listeners = new Set();

const notify = () => listeners.forEach((fn) => fn({ canInstall: !!deferredPrompt, installed }));

window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  deferredPrompt = e;
  notify();
});

window.addEventListener("appinstalled", () => {
  installed = true;
  deferredPrompt = null;
  notify();
});

export const getInstallState = () => ({ canInstall: !!deferredPrompt, installed });

export const subscribeInstall = (fn) => {
  listeners.add(fn);
  return () => listeners.delete(fn);
};

// Déclenche la boîte de dialogue d'installation native du navigateur.
// Retourne "accepted", "dismissed" ou "unavailable".
export const triggerInstall = async () => {
  if (!deferredPrompt) return "unavailable";
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  if (outcome === "accepted") installed = true;
  deferredPrompt = null;
  notify();
  return outcome;
};
